// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--b5vg5","under-construction":"_33974c2b58--under-construction--BLLUx","icon":"_33974c2b58--icon--MZJ73","name":"_33974c2b58--name--qjvhZ"};